import styled from "@emotion/styled";

import { useSelector } from "react-redux";
import { companiesSelector, currentSelector } from "../redux/slices/companiesSlice";
import { uiSelector } from "../redux/slices/uiSlice";

import LocationBarButton from "./ui/LocationBarButton";
import SearchBar from "./ui/SearchBar";

const LocationWrapper = styled.div`
  display: flex;
  padding: 16px;
  flex-wrap: wrap;
  max-height: 168px;
  overflow-y: auto;
`;

const getAccountId = (companyId = "") => String(companyId).split("-")[0];

const LocationBar = () => {
  const { companiesList } = useSelector(companiesSelector);
  const { currentId } = useSelector(currentSelector);
  const { locationQuery } = useSelector(uiSelector);

  const currentAccountId = getAccountId(currentId) || getAccountId(companiesList[0]?.company_id);
  const filteredLocations = companiesList.filter((i) =>
    getAccountId(i.company_id) === currentAccountId &&
    i.company_name.toLowerCase().includes(locationQuery.toLowerCase())
  );

  return (
    <>
        <SearchBar />
        <LocationWrapper>
          {filteredLocations.map((i) => (
            <LocationBarButton
              current={currentId === i.company_id}
              key={i.company_id}
              item={i}
            />
          ))}
        </LocationWrapper>
    </>
  );
};

export default LocationBar;
